import { useLocalSearchParams } from "expo-router"
import { trpc } from "utils/trpc"
import { ar } from "i18n/ar"
import { View, ActivityIndicator } from "react-native"
import { Header } from "components/Header"
import { List } from "@src/components/list"
import Icon from "@react-native-vector-icons/material-design-icons"
import { formatDateForDisplay, formatPrice, sharedStyles } from "@src/utils"
import { Text } from "components/core"

export default function Payment() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)
  const paymentHistory = trpc.employees.paymentHistory.useQuery({ id })
  const employee = trpc.employees.get.useQuery({ id })

  const header = <Header title={ar.paymentHistory} />

  return (
    <>
      {header}
      <List
        contentContainerStyle={sharedStyles.contentContainer}
        onRefresh={paymentHistory.refetch}
        data={paymentHistory.data ?? []}
        keyExtractor={(item) => item.id.toString()}
        ListEmptyComponent={
          employee.isLoading || paymentHistory.isLoading ? (
            <ActivityIndicator className="mt-4 mx-auto" />
          ) : (
            <View className="flex-1 items-center justify-center p-5">
              <Text className="text-lg text-gray-600 text-center">{ar.noPaymentsFound}</Text>
            </View>
          )
        }
        renderItem={({ item }) => {
          const up = item.balanceAfter > item.balanceBefore
          return (
            <View key={item.id} className="bg-white rounded shadow-sm p-4 mb-3">
              <View className="flex-row justify-between items-center mb-2">
                <Text className="text-base font-medium">{formatDateForDisplay(item._date)}</Text>
                <View className="flex-row items-center">
                  <Icon name={up ? "arrow-up" : "arrow-down"} size={16} color={up ? "#10B981" : "#EF4444"} />
                  <Text className={`text-base font-bold ml-1 ${up ? "text-green-600" : "text-red-500"}`}>
                    {formatPrice(item.balanceAfter - item.balanceBefore)} {ar.egp}
                  </Text>
                </View>
              </View>
              <Text className="text-sm text-gray-600 mb-2 text-left">{item.note}</Text>
              <View className="flex-row justify-between border-t border-gray-200 pt-2 mt-1">
                <View className="items-start">
                  <Text className="text-xs text-gray-500">{ar.balanceBefore}</Text>
                  <Text className="text-sm font-medium">
                    {formatPrice(item.balanceBefore)} {ar.egp}
                  </Text>
                </View>
                <View className="items-end">
                  <Text className="text-xs text-gray-500">{ar.balanceAfter}</Text>
                  <Text className="text-sm font-medium">
                    {formatPrice(item.balanceAfter)} {ar.egp}
                  </Text>
                </View>
              </View>
            </View>
          )
        }}
      />
    </>
  )
}
